<script setup lang="ts">
import AppSlotView from '@/AppSlotView.vue';
import { apps, formatting, useLocalization, useOrderViewContext } from '@hantera/portal-app';

const orderViewContext = useOrderViewContext();
const t = useLocalization('components.order.customer');

</script>


<template>

  <div class="field-list">
      
    <div class="field">
      <div class="label customer-number">
        <span>{{ t('customerNumber') }}</span>
<!--          <button class="button&#45;&#45;link">Change</button>-->
        <!-- opens customer search dialog -->
        
      </div>
      <div class="value">
        {{ orderViewContext.state.customerNumber ?? '-' }}
      </div>
    </div>

    <template v-if="orderViewContext.state.customer?.createdAt">
      <div
        v-for="(fieldValue, fieldKey) in orderViewContext.state.customer.dynamic"
        :key="fieldKey"
        class="field"
      >
        <div class="label">
          {{ fieldKey }}
        </div>
        <div class="value">
          {{ fieldValue }}
        </div>
      </div>

      <div class="field">
        <div class="label customer-number">
          {{ t('customerSince') }}
        </div>
        <div class="value">
          {{ formatting.date(orderViewContext.state.customer.createdAt) }}
        </div>
      </div>

      <AppSlotView :slot="apps.orderViewSlots.sidebarCustomer" />
    </template>
    
  </div>

</template>

<style scoped>
.field {
  padding: 5px;
}

.label {
  font-size: 12px;
}

.customer-number {
  display: flex;
  justify-content: space-between;
}

.field {
  border-bottom: 1px solid hsl(var(--color-70));
}

.field:last-child {
  border-bottom: none;
}
</style>